/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "en-001": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-150": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-AE": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      },
      "en-AG": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-AI": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-AS": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      },
      "en-AT": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-AU": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yrs"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yrs ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yrs"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yrs ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtrs"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtrs ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtrs"
          },
          "past": {
            "one": "in {0} qtr ago",
            "other": "{0} qtrs ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wks"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wks ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wks"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wks ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hrs"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hrs ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hrs"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hrs ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} mins"
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} mins ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} mins"
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} mins ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} secs"
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} secs ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} secs"
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} secs ago"
          }
        }
      },
      "en-BB": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-BE": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-BI": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      },
      "en-BM": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-BS": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-BW": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-BZ": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-CA": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yrs."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yrs. ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yrs."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yrs. ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mos."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mos. ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mos."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mos. ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wks."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wks. ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wks."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wks. ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hrs."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hrs. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hrs."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hrs. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} mins."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} mins. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} mins."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} mins. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} secs."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} secs. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} secs."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} secs. ago"
          }
        }
      },
      "en-CC": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-CH": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-CK": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-CM": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-CX": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-CY": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-DE": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-DG": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-DK": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-DM": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-ER": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-FI": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-FJ": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-FK": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-FM": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-GB": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-GD": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-GG": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-GH": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-GI": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-GM": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-GU": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      },
      "en-GY": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-HK": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-IE": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-IL": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-IM": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-IN": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-IO": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-JE": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-JM": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-KE": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-KI": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-KN": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-KY": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-LC": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-LR": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-LS": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-MG": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-MH": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      },
      "en-MO": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-MP": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      },
      "en-MS": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-MT": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-MU": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-MW": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-MY": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-NA": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-NF": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-NG": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-NL": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-NR": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-NU": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-NZ": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-PG": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-PH": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-PK": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-PN": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-PR": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      },
      "en-PW": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-RW": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SB": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SC": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SD": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SE": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SG": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr",
          "1": "next qtr",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtrs"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtrs ago"
          },
          "-1": "last qtr"
        },
        "quarter-narrow": {
          "0": "this qtr",
          "1": "next qtr",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr"
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mth",
          "1": "next mth",
          "future": {
            "one": "in {0} mth",
            "other": "in {0} mth"
          },
          "past": {
            "one": "{0} mth ago",
            "other": "{0} mth ago"
          },
          "-1": "last mth"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SH": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SI": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SL": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SS": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SX": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-SZ": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-TC": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-TK": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-TO": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-TT": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-TV": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-TZ": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-UG": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-UM": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      },
      "en-US-POSIX": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      },
      "en-VC": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-VG": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-VI": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      },
      "en-VU": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-WS": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-ZA": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-ZM": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en-ZW": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "year-narrow": {
          "0": "this yr",
          "1": "next yr",
          "future": {
            "one": "in {0} yr",
            "other": "in {0} yr"
          },
          "past": {
            "one": "{0} yr ago",
            "other": "{0} yr ago"
          },
          "-1": "last yr"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr",
            "other": "in {0} qtr"
          },
          "past": {
            "one": "{0} qtr ago",
            "other": "{0} qtr ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "month-narrow": {
          "0": "this mo",
          "1": "next mo",
          "future": {
            "one": "in {0} mo",
            "other": "in {0} mo"
          },
          "past": {
            "one": "{0} mo ago",
            "other": "{0} mo ago"
          },
          "-1": "last mo"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "week-narrow": {
          "0": "this wk",
          "1": "next wk",
          "future": {
            "one": "in {0} wk",
            "other": "in {0} wk"
          },
          "past": {
            "one": "{0} wk ago",
            "other": "{0} wk ago"
          },
          "-1": "last wk"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr",
            "other": "in {0} hr"
          },
          "past": {
            "one": "{0} hr ago",
            "other": "{0} hr ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min",
            "other": "in {0} min"
          },
          "past": {
            "one": "{0} min ago",
            "other": "{0} min ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec",
            "other": "in {0} sec"
          },
          "past": {
            "one": "{0} sec ago",
            "other": "{0} sec ago"
          }
        }
      },
      "en": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "one": "in {0} year",
            "other": "in {0} years"
          },
          "past": {
            "one": "{0} year ago",
            "other": "{0} years ago"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "year-narrow": {
          "0": "this yr.",
          "1": "next yr.",
          "future": {
            "one": "in {0} yr.",
            "other": "in {0} yr."
          },
          "past": {
            "one": "{0} yr. ago",
            "other": "{0} yr. ago"
          },
          "-1": "last yr."
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "one": "in {0} quarter",
            "other": "in {0} quarters"
          },
          "past": {
            "one": "{0} quarter ago",
            "other": "{0} quarters ago"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "quarter-narrow": {
          "0": "this qtr.",
          "1": "next qtr.",
          "future": {
            "one": "in {0} qtr.",
            "other": "in {0} qtrs."
          },
          "past": {
            "one": "{0} qtr. ago",
            "other": "{0} qtrs. ago"
          },
          "-1": "last qtr."
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "one": "in {0} month",
            "other": "in {0} months"
          },
          "past": {
            "one": "{0} month ago",
            "other": "{0} months ago"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "month-narrow": {
          "0": "this mo.",
          "1": "next mo.",
          "future": {
            "one": "in {0} mo.",
            "other": "in {0} mo."
          },
          "past": {
            "one": "{0} mo. ago",
            "other": "{0} mo. ago"
          },
          "-1": "last mo."
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "one": "in {0} week",
            "other": "in {0} weeks"
          },
          "past": {
            "one": "{0} week ago",
            "other": "{0} weeks ago"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "week-narrow": {
          "0": "this wk.",
          "1": "next wk.",
          "future": {
            "one": "in {0} wk.",
            "other": "in {0} wk."
          },
          "past": {
            "one": "{0} wk. ago",
            "other": "{0} wk. ago"
          },
          "-1": "last wk."
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "one": "in {0} day",
            "other": "in {0} days"
          },
          "past": {
            "one": "{0} day ago",
            "other": "{0} days ago"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "in {0} hour",
            "other": "in {0} hours"
          },
          "past": {
            "one": "{0} hour ago",
            "other": "{0} hours ago"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "in {0} hr.",
            "other": "in {0} hr."
          },
          "past": {
            "one": "{0} hr. ago",
            "other": "{0} hr. ago"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "in {0} minute",
            "other": "in {0} minutes"
          },
          "past": {
            "one": "{0} minute ago",
            "other": "{0} minutes ago"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "in {0} min.",
            "other": "in {0} min."
          },
          "past": {
            "one": "{0} min. ago",
            "other": "{0} min. ago"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "one": "in {0} second",
            "other": "in {0} seconds"
          },
          "past": {
            "one": "{0} second ago",
            "other": "{0} seconds ago"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "one": "in {0} sec.",
            "other": "in {0} sec."
          },
          "past": {
            "one": "{0} sec. ago",
            "other": "{0} sec. ago"
          }
        }
      }
    },
    "availableLocales": ["en-001", "en-150", "en-AE", "en-AG", "en-AI", "en-AS", "en-AT", "en-AU", "en-BB", "en-BE", "en-BI", "en-BM", "en-BS", "en-BW", "en-BZ", "en-CA", "en-CC", "en-CH", "en-CK", "en-CM", "en-CX", "en-CY", "en-DE", "en-DG", "en-DK", "en-DM", "en-ER", "en-FI", "en-FJ", "en-FK", "en-FM", "en-GB", "en-GD", "en-GG", "en-GH", "en-GI", "en-GM", "en-GU", "en-GY", "en-HK", "en-IE", "en-IL", "en-IM", "en-IN", "en-IO", "en-JE", "en-JM", "en-KE", "en-KI", "en-KN", "en-KY", "en-LC", "en-LR", "en-LS", "en-MG", "en-MH", "en-MO", "en-MP", "en-MS", "en-MT", "en-MU", "en-MW", "en-MY", "en-NA", "en-NF", "en-NG", "en-NL", "en-NR", "en-NU", "en-NZ", "en-PG", "en-PH", "en-PK", "en-PN", "en-PR", "en-PW", "en-RW", "en-SB", "en-SC", "en-SD", "en-SE", "en-SG", "en-SH", "en-SI", "en-SL", "en-SS", "en-SX", "en-SZ", "en-TC", "en-TK", "en-TO", "en-TT", "en-TV", "en-TZ", "en-UG", "en-UM", "en-US-POSIX", "en-US", "en-VC", "en-VG", "en-VI", "en-VU", "en-WS", "en-ZA", "en-ZM", "en-ZW", "en"]
  });
}